import { useState } from 'react'
import Input from '.'
import { Counter } from './styles'

interface TextAreaProps {
    id: string
    label?: string
    placeholder?: string
    isDisabled?: boolean
    isRequired?: boolean
    onChange?: (value: string) => void
    onBlur?: (value: string) => void
    isError?: boolean
    errorMessage?: string
    infoMessage?: string
    maxCharacters?: number
    hasNoMaxWidth?: boolean
    valueProp?: string
    testId?: string
}

const TextArea = ({
    placeholder,
    id,
    label,
    isDisabled,
    isRequired = false,
    onChange,
    onBlur,
    isError,
    errorMessage,
    infoMessage,
    maxCharacters,
    hasNoMaxWidth = false,
    valueProp,
    testId,
}: TextAreaProps) => {
    const [characters, setCharacters] = useState(0)

    const handleOnChange = (value: string) => {
        if (maxCharacters) {
            if (value.length <= maxCharacters) {
                setCharacters(value.length)
                onChange && onChange(value)
            }
        } else {
            onChange && onChange(value)
        }
    }

    return (
        <Input
            type="textarea"
            placeholder={placeholder}
            id={id}
            label={label}
            isDisabled={isDisabled}
            isRequired={isRequired}
            onValueChange={handleOnChange}
            onBlurChange={onBlur}
            isError={isError}
            errorMessage={errorMessage}
            infoMessage={infoMessage}
            value={valueProp}
            hasNoMaxWidth={hasNoMaxWidth}
            testId={testId}
        >
            {maxCharacters ? (
                <Counter
                    variant="body"
                    color="grayscale_700"
                    style={{ backgroundColor: 'transparent' }}
                >
                    {characters} / {maxCharacters}
                </Counter>
            ) : (
                <></>
            )}
        </Input>
    )
}

export default TextArea
